import { twMerge } from 'tailwind-merge';
import Jungle from '@/assets/jungle-1.jpg';

interface AuthFormProps
  extends React.DetailedHTMLProps<
    React.FormHTMLAttributes<HTMLFormElement>,
    HTMLFormElement
  > {
  imageSrc?: string;
  shellTopLeft?: React.ReactNode;
}

export const AuthForm: React.FC<AuthFormProps> = ({
  children,
  className,
  imageSrc,
  shellTopLeft,
  ...props
}) => (
  <div className='relative min-h-screen overflow-hidden bg-[#f7f5f2] px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8'>
    <div className='bg-primary/15 absolute left-0 top-0 h-72 w-72 rounded-full blur-3xl' />
    <div className='absolute bottom-0 right-0 h-80 w-80 rounded-full bg-secondary/10 blur-3xl' />

    <div className='relative grid min-h-[calc(100vh-2rem)] overflow-hidden rounded-[2rem] border border-white/70 bg-white/70 shadow-[0_45px_120px_-65px_rgba(15,23,42,0.45)] backdrop-blur-sm lg:grid-cols-[minmax(0,1fr)_minmax(0,1.02fr)] xl:min-h-[calc(100vh-4rem)]'>
      {shellTopLeft && (
        <div className='absolute left-1/2 top-6 z-20 -translate-x-1/2 sm:left-10 sm:top-10 sm:translate-x-0 xl:left-12 xl:top-12'>
          {shellTopLeft}
        </div>
      )}

      <div className='relative flex'>
        <div className='absolute left-10 top-10 hidden h-40 w-40 rounded-full bg-primary/10 blur-3xl lg:block' />
        <div className='absolute bottom-0 right-0 hidden h-48 w-48 rounded-full bg-secondary/10 blur-3xl lg:block' />

        <form
          {...props}
          className={twMerge(
            'relative z-10 mx-auto flex w-full max-w-[34rem] flex-col justify-center gap-4 px-5 pb-8 pt-20 text-center text-black sm:px-8 sm:pb-10 sm:pt-24 lg:gap-5 lg:px-12 lg:py-16 lg:text-left',
            className
          )}>
          {children}
          {/* <LanguageSwitch /> */}
        </form>
      </div>

      <div className='relative hidden lg:block'>
        <div className='absolute inset-6 overflow-hidden rounded-[1.75rem] bg-black shadow-[0_35px_90px_-45px_rgba(15,23,42,0.8)] xl:inset-8 xl:rounded-[2rem]'>
          <div
            style={{ backgroundImage: `url(${imageSrc ?? Jungle})` }}
            className='h-full w-full scale-[1.02] bg-cover bg-center'
          />

          <div className='absolute inset-0 bg-gradient-to-br from-[#081229]/5 via-transparent to-[#081229]/40' />
          <div className='ring-white/15 absolute inset-0 ring-1 ring-inset' />
          <div className='absolute left-10 top-10 h-32 w-32 rounded-full border border-white/20 bg-white/10 blur-3xl' />
          <div className='bg-primary/15 absolute bottom-12 right-10 h-40 w-40 rounded-full blur-3xl' />
        </div>
      </div>
    </div>
  </div>
);
